/**
 * @generated SignedSource<<1e6789595e4703199b51e321fa7b0dd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateCell_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_data">;
  readonly " $fragmentType": "RoomRatesTableRateCell_data";
};
export type RoomRatesTableRateCell_data$key = {
  readonly " $data"?: RoomRatesTableRateCell_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateCell_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditor_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "725805d263e3919f571ccb98d067bd27";

export default node;
